module.exports = __webpack_public_path__ + "assets/HypotenuseAndAltitudeDetailed.74fafb1d1cc836fb12ec3b865e328407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/HypotenuseAndAltitudeDetailed.png
// module id = 522
// module chunks = 0